import { useAppDispatch } from "../hooks";
import { INewCategory } from "../interfaces/new-category.interface";
import { createCategory } from "../services/firestore.service";
import { dismiss } from "../slices/dialogsSlice";

interface AddCategoryDialogProps {
    updateCategories: () => void;
    orderId: number;
    projectId: string;
    dialogId: number;
}

const AddCategoryDialog = ({
    updateCategories,
    orderId,
    projectId,
    dialogId,
}: AddCategoryDialogProps): React.JSX.Element => {
    const dispatch = useAppDispatch();

    const close = () => {
        dispatch(dismiss(dialogId));
    };

    const saveCategory = (e) => {
        e.preventDefault();

        let data = new FormData(e.target);

        let newCategory: INewCategory = {
            orderId: orderId,
            title: data.get("title").toString(),
            description: data.get("description").toString(),
        };

        createCategory(projectId, newCategory).then(() => {
            updateCategories();
            close();
        });
    };

    return (
        <>
            <form onSubmit={saveCategory}>
                <h1>Add a new Category</h1>
                <input placeholder="Title" name="title" />
                <input placeholder="Description" name="description" />
                <button type="submit">Save</button>
            </form>

            <button className="warn" onClick={close}>
                Cancel
            </button>
        </>
    );
};

export default AddCategoryDialog;
